import { render, staticRenderFns } from "./BLBPicture.vue?vue&type=template&id=b3d8642e&"
import script from "./BLBPicture.vue?vue&type=script&lang=js&"
export * from "./BLBPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports